import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface LoaderState {
    show: boolean;
    onlyBackgroundFlag: boolean;
    Message: string;
    opacity: number ;
}

@Injectable({
    providedIn: 'root',
})
export class LoaderService {

    // tslint:disable-next-line: max-line-length
    private loaderSubject = new BehaviorSubject<LoaderState>({show: false , onlyBackgroundFlag: false, Message: 'Loading...', opacity: .4 });
    loaderState = this.loaderSubject.asObservable();
    constructor() { }

    handleSpinnerFlag(loaderState: LoaderState) {
        this.loaderSubject.next(loaderState);
    }
}
